'use client';

import LandingFooter from '@/components/landing/footer';
import LandingHeader from '@/components/landing/landing-header';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen w-full flex-col">
      <LandingHeader />
      <main className="flex w-full flex-1">{children}</main>
      <LandingFooter />
    </div>
  );
}
